"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ACCESSIBLE_FRANCHISOR_PENDING = 'GET_ACCESSIBLE_FRANCHISOR_PENDING';
exports.GET_ACCESSIBLE_FRANCHISOR_ERROR = 'GET_ACCESSIBLE_FRANCHISOR_ERROR';
exports.GET_ACCESSIBLE_FRANCHISOR_SUCCESS = 'GET_ACCESSIBLE_FRANCHISOR_SUCCESS';
exports.GET_ACCESSIBLE_FRANCHISORS_PENDING = 'GET_ACCESSIBLE_FRANCHISORS_PENDING';
exports.GET_ACCESSIBLE_FRANCHISORS_ERROR = 'GET_ACCESSIBLE_FRANCHISORS_ERROR';
exports.GET_ACCESSIBLE_FRANCHISORS_SUCCESS = 'GET_ACCESSIBLE_FRANCHISORS_SUCCESS';
//# sourceMappingURL=constants.js.map